import React from 'react';

const ConfirmDialog = ({ isOpen, onYes, onNo, message, error }) => {
    if (!isOpen) {
        return null; // If the dialog is closed, do not render it
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white p-4 rounded shadow-lg">
                <h2 className="text-xl font-semibold mb-4">{message ?? "Are you sure you want to change?"}</h2>
                {
                    error && (
                        <h2 className="text-xl text-red-900 font-semibold mb-4">{error}</h2>
                    )
                }
                <div className="mt-4 flex justify-end">
                    <button
                        className="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 rounded mr-2"
                        onClick={onYes}
                    >
                        Yes
                    </button>
                    <button
                        className="bg-red-500 hover:bg-red-600 text-white py-2 px-4 rounded"
                        onClick={onNo}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;